<div class="product-row-item">
  <img
    *ngIf="!!coverImgId"
    class="product-row-item__image"
    [src]="coverImgId | getImageSrc: 'Product image' : 'thumbnail' : externalUnionId"
    alt="Product cover"
  />
  <div class="product-row-item__info">
    <app-badge *ngIf="!!discountText" class="discount" [color]="'blue'" [size]="'l'" [value]="discountText"></app-badge>
    <div class="name">{{ product?.name }}</div>
  </div>
</div>
